<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-29 11:27:19
-->
<template>
  <div>
    <mrc_ess_table
      v-if="$route.name == 'organizationalManagement'"
      :headers="headers"
      pageName="addOrganizationalManagement"
      :hideAddBtn="!hasBtn('add-organization-change')"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :slotKey="[
        'result_status',
        'change_effective',
        'change_status_uuid',
        'origin_dept_uuid',
        'new_dept_uuid',
      ]"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template #item.change_effective="{item}">
        <span>{{ item.change_effective | changeDate() }}</span>
      </template>

      <template #item.origin_dept_uuid="{item}">
        {{ INT(item.origin_dept_uuid) }}
      </template>

      <template #item.new_dept_uuid="{item}">
        {{ INT(item.new_dept_uuid) }}
      </template>

      <template #item.change_status_uuid="{item}">
        {{ INT(item.change_status_uuid) }}
      </template>

      <!-- 执行状态 -->
      <template v-slot:item.result_status="{ item }">
        <mrc_ess_viewbtn
          :is_used="item.result_status_save_value"
          :label="item.result_status"
        ></mrc_ess_viewbtn>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list
          :list="[
            {
              name: $t('label_View'),
              show: hasBtn('view-organization-change'),
              type: 'view',
            },
            {
              name: $t('label_Edit'),
              show:
                hasBtn('edit-organization-change') &&
                item.result_status_save_value === '0',
              type: 'edit',
            },
            {
              name: $t('label_delete'),
              show:
                hasBtn('delete-organization-change') &&
                item.result_status_save_value === '0',
              type: 'del',
            },
          ]"
          @handleClick="handleClick($event, item)"
        >
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'view-organization-change',
                'edit-organization-change',
                'delete-organization-change',
              ]"
              >mdi-dots-vertical</v-icon
            >
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import {
  getOrganizationalManagementList,
  detailOrganizationalManagement,
  addOrganizationalManagement,
  updateOrganizationalManagement,
  deleteOrganizationalManagement,
} from "@/service/api/OrganizationalManagement.js"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      stepIndex: 1,
      dialog: false,
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
      select_arr: [],
    }
  },
  computed: {
    stepList() {
      return [
        {
          name: this.$t("label_Importing_files"),
        },
        {
          name: this.$t("label_result"),
        },
      ]
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-organization-change"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-organization-change"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-organization-change"),
          type: "del",
        },
      ]
    },
    headers() {
      return [
        {
          text: this.$t("label_The_original_department"),
          value: "origin_dept_uuid",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("label_changeStatus"),
          value: "change_status_uuid",
          sortable: false,
        },
        {
          text: this.$t("label_New_department"),
          value: "new_dept_uuid",
          sortable: false,
        },
        {
          text: this.$t("label_Effective_date"),
          value: "change_effective",
          sortable: false,
        },
        {
          text: this.$t("label_The_execution_status"),
          value: "result_status",
          sortable: false,
          align: "center",
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    $route(v) {
      if (v.name == "organizationalManagement") {
        this.getlist()
      }
    },
  },
  async mounted() {
    this.$getDictName({ dict_name: "dept-change-type" }).then((res) => {
      if (res.code == 200) {
        this.select_arr = res.data
      }
    })
    await this.getlist()
  },
  beforeDestroy() {},
  methods: {
    changeIndex(v) {
      if (v == 0) {
        this.dialog = false
      } else if (v == 3) {
        //提交代码逻辑
      } else {
        this.stepIndex = v
      }
    },
    async getlist(obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await getOrganizationalManagementList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        org_level_uuid: this.$store.state.currentCompany,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    addStaffLeave() {
      this.$store.commit("set_subPage_name", "")
      this.$store.commit("set_uuid", "")
      this.$store.commit("set_iconstatus", "") //行内进图标显示
      this.$router.push({
        name: "addOrganizationalManagement",
      })
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      // this.$store.commit('set_subPage_name', item.job_name)
      this.$store.commit("set_uuid", item.uuid) //
      this.$router.push({
        name: "detailOrganizationalManagement",
      })
    },
    handleClick({ index, item }, obj) {
      switch (item.type) {
        case "view":
          this.$store.commit("set_listObj", obj) //保存这条数据
          this.godetail(obj)
          break
        case "edit":
          // this.$store.commit('set_subPage_name', obj.job_name)
          this.$store.commit("set_listObj", obj) //保存这条数据
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailOrganizationalManagement",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteOrganizationalManagement({ uuid: obj.uuid }).then((res) => {
              if (res.code === "200") {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                if (this.desserts.length == 1) this.options.cpage--
                this.getlist()
              }
            })
          })
          break
      }
    },
    success() {},
    cancel() {},
  },
}
</script>

<style scoped></style>
